// extracted by mini-css-extract-plugin
module.exports = {"control":"Input_control__oRs6S","controlLocked":"Input_controlLocked__GYzfG","lockButton":"Input_lockButton__6QNiZ"};